/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { getWindowsConfigurations } from "../../utils/Utils";

export default function Bauhaus2w2l(props) {
  const {
    wallWidth,
    wallHeight,
    originalWidth,
    originalHeight,
    leftMount,
    rightMount,
  } = props;
  const group = useRef();
  const { nodes, materials } = useGLTF(
    "/glbs/products/Bauhaus_1400_2w_window-NEW.glb"
  );

  const material = nodes["Left-v"].material;
  material.color.set(props.color);

  const material2 = materials["Aluminum- Klil-Black"];
  material2.color.set(props.color);

  const windowsSettings = {
    sizes: {
      vertical: originalWidth / 2,
      horizontal: originalHeight,
    },
    coeficients: {
      vertical: 1,
      horizontal: 1,
    },
  };

  const windowsConfigurations = getWindowsConfigurations({
    settings: windowsSettings,
    mountings: [
      { orientation: "vertical", position: "left-v", mount: leftMount.v },
      { orientation: "horizontal", position: "left-h", mount: leftMount.h },
      { orientation: "horizontal", position: "right-h", mount: rightMount.h },
      { orientation: "vertical", position: "right-v", mount: rightMount.v },
    ],
  });

  let leftVertical = windowsConfigurations[0];
  let leftHorizontal = windowsConfigurations[1];
  let rightHorizontal = windowsConfigurations[2];
  let rightVertical = windowsConfigurations[3];

  function getWallWidth(wallWidth) {
    return wallWidth;
  }

  function getWallHeight(wallHeight) {
    return wallHeight;
  }

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        rotation={[-Math.PI / 2, 0, 0]}
        scale={0.3}
        position={[-0.03, 0, 0]}
      >
        <mesh
          name="Mesh_1"
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1.geometry}
          material={materials["Glass-Klil-Clear"]}
          morphTargetDictionary={nodes.Mesh_1.morphTargetDictionary}
          morphTargetInfluences={[
            getWallWidth(wallWidth),
            getWallHeight(wallHeight),
          ]}
        />
        <mesh
          name="Mesh_1_1"
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1_1.geometry}
          material={materials["Aluminum- Klil-Black"]}
          morphTargetDictionary={nodes.Mesh_1_1.morphTargetDictionary}
          morphTargetInfluences={[
            getWallWidth(wallWidth),
            getWallHeight(wallHeight),
          ]}
        />
        <mesh
          name="Mesh_1_2"
          castShadow
          receiveShadow
          geometry={nodes.Mesh_1_2.geometry}
          material={materials["Marble-Klil-Hebron"]}
          morphTargetDictionary={nodes.Mesh_1_2.morphTargetDictionary}
          morphTargetInfluences={[
            getWallWidth(wallWidth),
            getWallHeight(wallHeight),
          ]}
        />
        </group>
       
      {rightHorizontal.map((value, index) => {
        return (
          <mesh
            key={`${index}-right-h`}
            name="right-h"
            castShadow
            receiveShadow
            geometry={nodes["right-h"].geometry}
            material={materials["Aluminum- Klil-Black.003"]}
            morphTargetDictionary={nodes["right-h"].morphTargetDictionary}
            morphTargetInfluences={[
              getWallWidth(wallWidth),
              getWallHeight(wallHeight),
            ]}
            // position={[0, value, 0]}
            position={[-0.03, value, 0]}
          />
        );
      })}
      {leftHorizontal.map((value, index) => {
        return (
          <mesh
            key={`${index}-Left-h`}
            name="Left-h"
            castShadow
            receiveShadow
            geometry={nodes["Left-h"].geometry}
            material={materials["Aluminum- Klil-Black.003"]}
            morphTargetDictionary={nodes["Left-h"].morphTargetDictionary}
            morphTargetInfluences={[
              getWallWidth(wallWidth),
              getWallHeight(wallHeight),
            ]}
            position={[-0.03, value, 0]}
          />
        );
      })}
      {rightVertical.map((value, index) => {
        return (
          <mesh
            key={`${index}-right-v`}
            name="right-v"
            castShadow
            receiveShadow
            geometry={nodes["right-v"].geometry}
            material={materials["Aluminum- Klil-Black.003"]}
            morphTargetDictionary={nodes["right-v"].morphTargetDictionary}
            morphTargetInfluences={[
              getWallWidth(wallWidth),
              getWallHeight(wallHeight),
            ]}
            position={[value, 0, 0]}
          />
        );
      })}
      {leftVertical.map((value, index) => {
        return (
          <mesh
            key={`${index}-Left-v`}
            name="Left-v"
            castShadow
            receiveShadow
            geometry={nodes["Left-v"].geometry}
            material={materials["Aluminum- Klil-Black.003"]}
            morphTargetDictionary={nodes["Left-v"].morphTargetDictionary}
            morphTargetInfluences={[
              getWallWidth(wallWidth),
              getWallHeight(wallHeight),
            ]}
            position={[value, 0, 0]}
          />
        );
      })}
    </group>
  );
}

useGLTF.preload("/glbs/products/Bauhaus_1400_2w_window-NEW.glb");
